import { Environment } from './environment.type';

export const environment: Environment = {
    stage: 'sandbox',
    LPB_URL: 'https://sandbox-api.bannerflow.com/landing-page-builder',
    AA_URL: 'https://sandbox-api.bannerflow.com/account-access',
    LEGACY_URL: 'https://sandbox-api.bannerflow.com/legacy',
    HOME_URL: 'https://sandbox-home.bannerflow.com',
    LOGIN_URL: 'https://sandbox-login.bannerflow.com',
    CLIENT_ID: 'FbhS3JY110wqSENSiTBUeGIjCV1bmiT3',
    API_URLS: ['https://sandbox-api.bannerflow.com'],
    version: '',
    newRelic: {
        enabled: true,
        accountId: '4232543',
        trustKey: '4122654',
        agentId: '538764742',
        licenseKey: 'NRBR-3f0570f4ed63339c8d0',
        applicationId: '538764742',
        origins: ['https://sandbox-api.bannerflow.com']
    },
    featureFlags: {
        enabled: true,
        url: 'https://api.bannerflow.com/features/api/frontend',
        // Unleash frontend client keys are public and not sensitive (unlike API tokens)
        clientKey: '*:development.b00ab45f8b6f2247492d91e8de452bca1bfcd49b37dfdb3be6c69e1c'
    }
};
